import React, { useEffect, useState } from "react";
import { Button, Table, Spinner } from "react-bootstrap";
import up_down_arrow from "../../../../Assets/svg/up_down_arrow.svg";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import { del } from "../../../../helpers/api_helper";
import AddNewSecondaryPlanet from "./Modal/AddNewSecondaryPlanet";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TableData = ({ secondaryPlanet, setRefresh }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedSecondaryPlanet, setSelectedSecondaryPlanet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [planetToDelete, setPlanetToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("secondaryPlanet", "UPDATE");
  const hasDeletePermission = useCheckPermission("secondaryPlanet", "DELETE");

  useEffect(() => {
    if (secondaryPlanet && secondaryPlanet.length > 0) {
      setLoading(false);
    }
  }, [secondaryPlanet]);

  const handleDelete = async () => {
    try {
      const response = await del(`/planet/${planetToDelete}`);
      if (response.success) {
        setRefresh(true);
        toast.success("Secondary planet deleted successfully");
      } else {
        console.log(response.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (id) => {
    setPlanetToDelete(id);
    setShowConfirm(true);
  };

  const handleEdit = (data) => {
    setSelectedSecondaryPlanet(data);
    setModalMode("edit");
    setShowModal(true);
  };

  return (
    <>
      <AddNewSecondaryPlanet
        showModal={showModal}
        setShowModal={setShowModal}
        handleDataRefresh={() => setRefresh(true)}
        mode={modalMode}
        secondaryPlanetData={selectedSecondaryPlanet}
      />

      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal border-0">Ticker Name</th>
              <th className="fw-normal border-0">Stock Exchange Name</th>
              <th className="fw-normal border-0">Master Planet</th>
              <th className="fw-normal border-0">Secondary Planet</th>

              <th className="fw-normal border-0">Status</th>
              <th className="fw-normal border-0">Action</th>
            </tr>
          </thead>
          <tbody>
            {secondaryPlanet && secondaryPlanet.length > 0 ? (
              secondaryPlanet?.map((data, key) => (
                <tr key={key}>
                  <td>{data?.master_planet?.stock?.ticker_name ? data?.master_planet?.stock?.ticker_name : "-"}</td>

                  <td>
                    {data?.master_planet?.stock?.stock_name
                      ? data?.master_planet?.stock?.stock_name
                      : "-"}
                  </td>

                  <td className="text-capitalize">
                    <span className="labelTag greenLabel">
                      {data?.master_planet?.name
                        ? data?.master_planet?.name
                        : "-"}
                    </span>
                  </td>
                  <td className="text-capitalize">
                    {data?.name ? data?.name : "-"}
                  </td>
                  <td>
                    <span className="text-capitalize labelTag greenLabel">
                      {data?.status ? data?.status : "-"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      {hasUpdatePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => handleEdit(data)}
                      >
                        <img src={action_icon_1} alt="" />
                      </Button>}
                      {hasDeletePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => confirmDelete(data?._id)}
                      >
                        <img src={action_icon_2} alt="" />
                      </Button>}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default TableData;
